import { createListLoader } from '@/store/utils/loader';

export default createListLoader({
  namespaced: true,
  config: {
    url: '/projects/api/v3/companies.json',
    params: ({ company }) => ({
      searchTerm: company.filtered.searchTerm,
      ...(company.filtered.restrictedCurrencyId && { currencyId: company.filtered.restrictedCurrencyId }),
      include: 'currencies',
    }),
    module: 'company',
    mapResponse: (ctx, rs) => {
      const { companies, included = {} } = rs.data;
      const { currencies = {} } = included;
      return companies.map((company) => ({
        ...company,
        currency: currencies[company.currency?.id] ?? company.currency,
      }));
    },
  },
  state: {
    searchTerm: '',
    restrictedCurrencyId: null,
  },
  mutations: {
    search: (state, term) => {
      state.searchTerm = term;
    },
    restrictCurrency: (state, currencyId) => {
      state.restrictedCurrencyId = currencyId;
    },
  },
});
